import AccordionStyle from "Componentes/Accordion/style.module.scss";
import AccordionItem, { AccordionProps } from "./AccordionItem";

type QuestionsProps = {
  questions: Array<AccordionProps>;
};

const Accordion: React.FC<QuestionsProps> = ({ questions }) => {
  return (
    <div className='container p-3 text-muted'>
      <div
        className={`${AccordionStyle.accordion}`}
        data-testid='claseAccordion'>
        {questions.map(({ answer, reply }, index) => (
          <AccordionItem key={index} answer={answer} reply={reply} />
        ))}
      </div>
    </div>
  );
};

export default Accordion;
